import React from "react";
import { Box, Button, HStack, Icon, IconButton } from "@chakra-ui/react";
import TraitsCanvas from "components/TraitsCanvas";
import { FaRedo, FaUndo } from "react-icons/fa";
import useTranslate from "hooks/useTranslate";
import useDressingRoom from "hooks/useDressingRoom";

const TraitsPreviewContainer = () => {
  const translate = useTranslate();
  const {
    initialTraits,
    currentTraits,
    undoSwap,
    redoSwap,
    canUndo,
    canRedo,
    resetTraits,
  } = useDressingRoom();

  return (
    <Box p="3" bg="bright.500" w="full">
      <Box overflow="hidden" position="relative">
        <HStack
          spacing="0"
          position="absolute"
          top="-3"
          right="-3"
          p="3"
          bg="bright.500"
          zIndex="1"
        >
          <IconButton
            size="sm"
            variant="link"
            onClick={undoSwap}
            icon={<Icon as={FaUndo} w="5" h="5" />}
            aria-label=""
            isDisabled={!canUndo}
          />
          <IconButton
            size="sm"
            variant="link"
            onClick={redoSwap}
            icon={<Icon as={FaRedo} w="5" h="5" />}
            aria-label=""
            isDisabled={!canRedo}
          />
          <Box>
            <Button
              ml="2"
              size="sm"
              variant="outline"
              onClick={resetTraits}
              isDisabled={!canUndo}
            >
              {translate("common:reset")}
            </Button>
          </Box>
        </HStack>

        {initialTraits && currentTraits && (
          <TraitsCanvas
            color={currentTraits[1]}
            traits={currentTraits}
            imagesSize="1024"
          />
        )}
      </Box>
    </Box>
  );
};

export default TraitsPreviewContainer;
